import React, { useState, useRef, useEffect } from "react";
import GlossaryIcon from "../../glossary-icons-block/components/glossary-icon";
import { IGlossaryIconModel } from "../../glossary-icons-block/models/glossary-icons-block-models";
import { IGlossaryContentBlockModel } from "../models/glossary-page-models";
import GlossaryContentItem from "./glossary-content-item";
import { initializeAnchorLinks } from '../../../Static/javascript/modules/anchor-links';
interface IProps {
    glossaryContentItems: IGlossaryContentBlockModel[];
    relatedSocialMediaIcons: IGlossaryIconModel[];
    relatedSocialMediaPlatformsHeading: string;
    backCtaText: string;
    backCtaUrl: string;
    heading: string;
    noSearchResultsText: string;
    searchPlaceholderText: string;
    searchCtaText: string;
    topicText: string;
    topicTextForMobile: string;
}

const GlossaryPageApp = (props: IProps) => {
    const [searchInput, setSearchInput] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [toggleFilters, setToggleFilters] = useState(false)
    const [activeItem, setActiveItem] = useState(null)

    let glossaryContentItemsToDisplay: IGlossaryContentBlockModel[] = props.glossaryContentItems;
    if (searchTerm && searchTerm.length > 0) {
        glossaryContentItemsToDisplay = glossaryContentItemsToDisplay.filter(i => getGlossaryContentItemText(i).includes(cleanString(searchTerm)));
    }

    function getGlossaryContentItemText(item: IGlossaryContentBlockModel): string {
        return cleanString(item.heading) + getTextFromWysiwyg(item.description);
    }

    function getTextFromWysiwyg(html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return cleanString(tmp.textContent) || cleanString(tmp.innerText) || "";
    }

    function cleanString(str: string): string {
        //Clean new line and space characters
        if (str) {
            str = replaceAll(str, '\n', '');
            str = str.replace(/\s/g,
                '');
            return str.toLowerCase();
        }
        return "";
    }

    function replaceAll(str: string, find: string, replace: string): string {
        if (str) {
            return str.replace(new RegExp(find.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), replace);
        }
        return "";
    }

    const contentRef = useRef(null);

    const scrollLevelIntoView = (id) => {
        setTimeout(() => {
            let contentNode = contentRef.current as HTMLElement;
            contentNode.querySelector(`#${id}`).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }, 0);
    };

    useEffect(() => {
        if (activeItem) {
            scrollLevelIntoView(activeItem)
        }
    }, [activeItem])

    useEffect(() => {
        initializeAnchorLinks();
        window.Tooltips();
    }, [])

    function clearSearchInput() {
        setSearchInput('');
        (document.getElementById('SearchText') as HTMLInputElement).focus();
    }


    return (
        <>
            <div className="glossary-container">
                {props.backCtaText && props.backCtaUrl &&
                    <a href={props.backCtaUrl} className="btn button-primary glossary-back-cta">
                        <svg className="svg-icon"> <use xlinkHref="#arrow-left" /> </svg>
                        {props.backCtaText}
                    </a>}

                <div className="glossary-search">
                    <div className="search-bar ">
                        <div className="search-bar-area-custom">
                            <div className="search-bar-area-input homepage-main-search">
                                <label className="hidden-label" htmlFor="txt_search">Search Text</label>
                                <input id="SearchText" name="SearchText" type="text" value={searchInput} onChange={e => setSearchInput(e.target.value)} placeholder={props.searchPlaceholderText} />
                                <svg className="magnifying-glass"> <use xlinkHref="#info-magnifying-glass" /> </svg>
                                {searchInput.length > 0 &&
                                    <div className="search-bar-area-input-clear" onClick={clearSearchInput}>
                                        <svg><use xlinkHref="#icon-x-circle"></use></svg>
                                    </div>
                                }
                            </div><button className="search-bar-area-btn" type="submit" onClick={() => setSearchTerm(searchInput)}> {props.searchCtaText}</button>
                        </div>
                    </div>
                </div>

                <div className="glossary-topics-mobile">
                    <button className="un-button glossary-topics-mobile-trigger" onClick={() => setToggleFilters(!toggleFilters)}>
                        <span>{props.topicTextForMobile}</span>
                        <svg className="svg-icon"> <use xlinkHref="#plus-icon" /> </svg>
                    </button>

                    {toggleFilters &&
                        <div className="glossary-topics">
                            <span className="paragraph-small-sans bold">Jump To</span>
                            {glossaryContentItemsToDisplay.map((item, index) =>
                                <button type="button" className="glossary-topic un-button" onClick={() => { setActiveItem(`item-${item.id}`); setToggleFilters(false); }}>{item.heading}</button>
                            )}
                        </div>
                    }
                </div>
            </div>
            <div className="glossary-container" data-anchor-links-container>
                <div className="glossary-sidebar">

                    <div className="glossary-sidebar-item glossary-topics-desktop" >
                        <h3 className="glossary-sidebar-icons-title">{props.topicText}</h3>
                        <div className="glossary-topics" data-anchor-links="">
                        </div>
                    </div>
                    {props.relatedSocialMediaIcons.length > 0 &&
                        <div className="glossary-sidebar-item">
                            <h3 className="glossary-sidebar-icons-title">{props.relatedSocialMediaPlatformsHeading}</h3>

                            <div className="glossary-sidebar-icons">
                                {props.relatedSocialMediaIcons.map((icon, index) =>
                                    <GlossaryIcon glossaryIcon={icon} />
                                )}
                            </div>
                        </div>
                    }
                </div>

                <div className="glossary-content">

                    <div className="glossary-results">
                        <div className="glossary-results-title">
                            <h2> {props.heading}</h2>
                        </div>

                        <div className="glossary-results-container" ref={contentRef} >

                            {glossaryContentItemsToDisplay.length == 0 && searchTerm.length > 0 &&
                                <p className="h5-styled">{props.noSearchResultsText}</p>
                            }
                            {glossaryContentItemsToDisplay.map((item, index) =>
                                <GlossaryContentItem key={index} glossaryContentItem={item} />
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default GlossaryPageApp